import { piloteerApi } from './piloteer';

export const {
  useLazyCheckQuery,
  useGetOutageBannerQuery,
  // User hooks
  useGetUserQuery,
  useLazyGetUserQuery,
  useUpdateUserMutation,
  useUpdateProfilePictureMutation,
  // Meeting hooks
  useGetAllMeetingsQuery,
  useGetRecentMeetingsQuery,
  useLazyGetMeetingByUuidQuery,
  useGetMeetingByUuidQuery,
  useGetPublicMeetingByUuidQuery,
  useGetMeetingTranscriptQuery,
  useUpdateMeetingMutation,
  useGetLeadershipResonancesAggregatedQuery,
  useGetDimensionalReportsAggregatedQuery,
  // Session hooks
  useGetCombinedTableQuery,
  useGetRecentSessionsQuery,
  useLazyGetSessionByUuidQuery,
  useGetSessionByUuidQuery,
  useGetPublicSessionByUuidQuery,
  useGetSessionDimensionalReportsQuery,
  useGetSessionAnalysisQuery,
  useUpdateSessionMutation,
  //Objective hooks
  useGetLatestObjectivesQuery,
  // Subscription hooks
  // Integration hooks
  useConnectZoomAccountMutation,
  useDisconnectZoomAccountMutation,
  useAuthorizeGoogleCalendarMutation,
  useGetGoogleCalendarsQuery,
  useGetIntegrationAccountQuery,
  useSelectGoogleCalendarMutation,
  useConnectGoogleCalendarMutation,
  useDisconnectGoogleCalendarMutation,
  useConnectMicrosoftCalendarMutation,
  useDisconnectMicrosoftCalendarMutation,
  // Calendar event hooks
  useSyncCalendarMutation,
  useGetCalendarEventsQuery,
  // Multi-tenant hooks
  // Channel Partner hooks
  useGetChannelPartnersQuery,
  useGetChannelPartnerByIdQuery,
  useCreateChannelPartnerMutation,
  useUpdateChannelPartnerMutation,
  useGetCompaniesByChannelPartnerQuery,
  useGetChannelPartnerDashboardQuery,
  useGetChannelPartnerDashboardByIdQuery,
  // Company hooks
  useGetCompaniesQuery,
  useGetCompanyByIdQuery,
  useCreateCompanyMutation,
  useUpdateCompanyMutation,
  useGetCompanyStatsQuery,
  // Team hooks
  useGetTeamsQuery,
  useGetTeamByIdQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useAddTeamMemberMutation,
  useRemoveTeamMemberMutation,
  // Analytics hooks
  useGetRoleBasedDashboardQuery,
  // Company User Management hooks
  useGetCompanyUsersQuery,
  useInviteUsersToCompanyMutation,
  useUpdateUserRoleMutation,
  useBulkUserOperationsMutation,
  useResendUserInvitationMutation,
  useDeactivateUserMutation,
  useActivateUserMutation,
  useUpdateUserDisclosureRequiredMutation,
  useGetCompanyDisclosureSettingsQuery,
  useUpdateCompanyDisclosureRequiredMutation,
  // Onboarding hooks
  useOnboardCompanyMutation,
  useAddUsersToCompanyMutation,
  useGetMyOnboardedCompaniesQuery,
  useGetOnboardedCompanyDetailsQuery,
  // Performance Loop hooks
  useGetPerformanceLoopQuery,
  // Insight hooks
  useGetMyAggregateInsightQuery,
  useGetCompanyAggregateInsightQuery,
  useGetTeamAggregateInsightQuery,
  useGetUserAggregateInsightQuery,
  // Chat hooks
  useQuickChatMutation,
  useChatMutation,
  useGetChatCapabilitiesQuery,
  useChatStreamMutation,
  // Localization hooks
  useGetCompanyLocalizationQuery,
  useUpdateCompanyLocalizationMutation,
  // Company Document hooks
  useGetCompanyDocumentsQuery,
  useUploadCompanyDocumentMutation,
  useDeleteCompanyDocumentMutation,
} = piloteerApi;

export { piloteerApi };
